import Api from "@/services/api.js";
import vCenario from "@/components/v-cenario/v-cenario.vue";
import vCaptcha from "@/components/v-captcha/v-captcha.vue";
// import CnpjCaptcha from "@/components/CnpjCaptcha/CnpjCaptcha.vue";
import vResultado from "@/components/v-resultado/v-resultado.vue";
import vTutorialCenarios from "@/components/tutorial/v-tutorial-cenarios.vue";
import Scroll from "@/components/Scroll.vue";
import NavCenario from "@/components/NavCenario/NavCenario.vue";
import ListaCenarios from "@/modules/Cenario/components/ListaCenarios.vue";
import InvertCenarios from "@/modules/Cenario/components/InvertCenarios.vue";
import ModalImpressao from "@/components/impressao/ModalImpressao.vue";
import ModalIcmsInterestadual from "@/components/ModalIcmsInterestadual/ModalIcmsInterestadual.vue";
import CalendarioObrigacoes from "@/components/CalendarioObrigacoes/CalendarioObrigacoes.vue";
import AbasResultado from "@/components/AbasResultado/AbasResultado.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

import router from "../../router";
import { mapGetters, mapActions } from "vuex";
import rotaBufferMixin from "@/mixins/rotaBufferMixin";
import IconeResumo from "../../components/IconeResumo/IconeResumo.vue";
import ModalAtalhos from "@/components/ModalCenario/ModalAtalhos.vue";
import ModalSalvar from "@/components/ModalCenario/ModalSalvar.vue";
import ModalLimpar from "@/components/ModalCenario/ModalLimpar.vue";
import ModalRemover from "@/components/ModalCenario/ModalRemover.vue";
import ModalCompreende from "@/components/ModalCompreende/ModalCompreende.vue";
import PaginaTitulo from "@/components/PaginaTitulo/PaginaTitulo.vue";

var $ = require("jquery");
export default {
  // props: ["empresa"],
  components: {
    vCenario,
    vCaptcha,
    vResultado,
    vTutorialCenarios,
    Scroll,
    NavCenario,
    ListaCenarios,
    InvertCenarios,
    ModalImpressao,
    IconeResumo,
    CalendarioObrigacoes,
    // CnpjCaptcha,
    ModalSalvar,
    ModalLimpar,
    ModalRemover,
    ModalIcmsInterestadual,
    AbasResultado,
    BotaoPadrao,
    ModalCompreende,
    PaginaTitulo,
    LoadingPadraoContainer,
    ModalAtalhos
  },
  inject: ["pushAlert"],
  mixins: [rotaBufferMixin],
  data() {
    return {
      cnaeSelecionadaCompreende: null,
      modalImpressaoToggle: false,
      similarNacionalAliquota: null,
      bssnId: null,
      blShow: false,
      bssnSelecionado: [],
      modalSimilarAtivo: false,

      formValido: {
        cenario1: false,
        cenario2: false,
        cenario3: false
      },
      cenarioId: null,
      nomeCenarioModal: null,
      numeroSlide: null,
      chamaSalvar: false,
      chamaLimpar: false,
      chamaRemover: false,
      numeroNomeCenario: 1,
      cenarioCnpjRemetente: [],
      cenarioCnpjDestinatario: [],
      impostoSelecionadoImpressao: [],
      dataCenario: [],
      loadingResultadoCenario: [
        {
          id: 1,
          loading: false
        },
        {
          id: 2,
          loading: false
        },
        {
          id: 3,
          loading: false
        }
      ],
      loadingPerguntas: false,
      blLoadingImpressao: false,
      impostosChamados: [],
      slides: [],
      idUsuario: 1,
      idRegra: [],
      lista_cenarios: [],
      arCenariosSalvos: [],
      btn_maximixar: false,
      btn_minimizar: true,
      mostraCamposC: true,
      idModalCaptcha: -1,
      cnpjModalCaptcha: "",
      dadosResultado: [],
      loading: false,
      erroResultado: false,
      alertas: [],
      exibeResumoCenario: {
        1: false,
        2: false,
        3: false
      },
      dadosResumoCenario: {
        1: {
          nome: "",
          termo: "",
          ncm: "",
          atividade_remetente: "",
          selected_tipo_atividade_destinatario: "",
          selected_origem_mercadoria: "",
          selected_destinacao: "",
          selected_local: "",
          selected_estado_origem: "",
          selected_pais_origem: "",
          selected_pais_destino: "",
          selected_estado_destino: "",
          descrTipi: "",
          descricao: ""
        },
        2: {
          nome: "",
          termo: "",
          ncm: "",
          atividade_remetente: "",
          selected_tipo_atividade_destinatario: "",
          selected_origem_mercadoria: "",
          selected_destinacao: "",
          selected_local: "",
          selected_estado_origem: "",
          selected_pais_origem: "",
          selected_pais_destino: "",
          selected_estado_destino: "",
          descrTipi: "",
          descricao: ""
        },
        3: {
          nome: "",
          termo: "",
          ncm: "",
          atividade_remetente: "",
          selected_tipo_atividade_destinatario: "",
          selected_origem_mercadoria: "",
          selected_destinacao: "",
          selected_local: "",
          selected_estado_origem: "",
          selected_pais_origem: "",
          selected_pais_destino: "",
          selected_estado_destino: "",
          descrTipi: "",
          descricao: ""
        }
      },
      impostosFAKE: [],
      abaAtiva: "",
      vezes: "",
      arChecks: [],
      arChecksFundo: [],
      intTotalChecks: 0,
      idTutorial: 91,
      arChecksSelected: [],
      arChecksSelectedFundo: [],
      blImprimir: [],
      idSelecionado: "Cenario1",
      idCenarioSelecionado: 0,
      idCenarioReset: 0,
      //possuiAbasAtivas: false,
      VCenarioKey: {
        1: 0,
        2: 0,
        3: 0
      },
      tributosFAKE: {
        0: {
          id: "1",
          classe: "icms_interno",
          nome: "ICMS"
        },
        1: {
          id: "5",
          classe: "ipi",
          nome: "IPI"
        },
        2: {
          id: "6",
          classe: "class_importacao",
          nome: "IMPOSTO DE IMPORTAÇÃO"
        },
        3: {
          id: "8",
          classe: "exportacao",
          nome: "IMPOSTO DE EXPORTAÇÃO"
        },
        4: {
          id: "9",
          classe: "cide_combustivel",
          nome: "CIDE"
        },
        5: {
          id: "10",
          classe: "defesa_comercial",
          nome: "DEFESA COMERCIAL"
        },
        6: {
          id: "11",
          classe: "acordo_comercial",
          nome: "ACORDO COMERCIAL"
        },
        7: {
          id: "12",
          classe: "pis_cofins",
          nome: "PIS/COFINS"
        },
        8: {
          id: "13",
          classe: "class_cofins",
          nome: "PIS/COFINS IMPORTAÇÃO"
        },
        9: {
          id: "2",
          classe: "icms_importacao",
          nome: "ICMS"
        },
        10: {
          id: "17",
          classe: "icms_interno_st",
          nome: "ICMS ST"
        },
        11: {
          id: "18",
          classe: "preferencia_tarifaria",
          nome: "PREFERÊNCIA TARIFÁRIA"
        },
        12: {
          id: "19",
          classe: "carga_liquida",
          nome: "ICMS CARGA LÍQUIDA"
        },
        13: {
          id: "20",
          classe: "antecipacao",
          nome: "ICMS Antecipação Tributária"
        },
        14: {
          id: "21",
          classe: "difal",
          nome: "DIFAL"
        }
      },
      cenarioPrincipal: {
        id: 0,
        nome_cenario: "Cenário 1"
      },
      usuario_pro: false,
      acesso_simulado: localStorage.getItem("token_simulacao") ? true : false,
      arSelectRadio: [],
      arSelectFundo: [],
      fundoSelecionado: null,
      fakeArNcmSelecionados: [],
      dadosForm: [],
      blSN: false,
      arFormCenario: [],
      arDadosForm: [],
      cnaeModalLabel: "",
      cnaeCompreende: [],
      cnaeNaoCompreende: [],
      cnaeCompreendeDestinatario: [],
      cnaeNaoCompreendeDestinatario: [],
      loadingCompreende: false,
      produtosQuimicos: [],
      loadingProdutosQuimicos: false,
      descricaoQuimicos: "",
      mostrarST: false,
      arMostrarST: {
        0: false,
        1: false,
        2: false
      },
      limparCest: false,
      intLastIdCenario: 0,
      origemCompreende: "rem",
      blExibeResumo: false,
      blExibeResultado: false,
      exibeResultado: false,
      exibeCarregando: false,
      intContadorResultados: 0,
      elementBtnMaluco: 0,
      formularioValido: false,
      botaoResumoHover: false
      // blArrowsFixed: false,
    };
  },
  provide() {
    return {
      controleAbas: this.controleAbas,
      setExibeResultado: this.setExibeResultado,
      setExibeCarregando: this.setExibeCarregando,
      checaTodosFormularios: this.checaTodosFormularios,
      modalSimilarToggle: this.modalSimilarToggle,
      getDadosModalBssn: this.getDadosModalBssn,
      limpaSimilar: this.limpaSimilar
    };
  },
  watch: {
    dadosResumoCenario: function() {
      this.$forceUpdate();
    }
    // getImpostos: function (newVal, oldVal) {
    //   if (this.dadosResultado != newVal) {
    //     this.dadosResultado = newVal
    //   }
    // }
  },
  created: function() {
    this.numeroNomeCenario = 1;
    this.setFormulariosValidos(0);
    this.$bus.$off("buscarResultado");
    this.$bus.$off("validarFormulario");
    this.$bus.$off("exibirResumoCenario");

    this.scrollToTop();

    this.resetListCenarios();
    this.setModalInvertCenarios();
    this.resetInvertCenarios();

    this.carregaCenarios();

    //BUS REFATORACAO
    this.$bus.$on("limparImposto", imposto => {
      this.limpaImpostosChamados(imposto);
    });
    this.$bus.$on("limpaBuffer", () => {
      this.limpaChamadaBuffer();
    });
    //FIM

    this.$bus.$on("exibirResumoCenario", value => {
      this.exibirResumoCenario(value);
    });
    this.$bus.$on("abaAtiva", (status, tipoOperacao) => {
      this.reloadData(status, tipoOperacao);
    });
    this.$bus.$on("forcePositionCarousel", page => {
      this.forcePositionCarousel(page);
    });
    this.$bus.$on("changeCnaeRemetente", cnaeId => {
      this.checkDataCnaeCompreende(cnaeId, "rem");
    });
    this.$bus.$on("changeCnaeDestinatario", cnaeId => {
      this.checkDataCnaeCompreende(cnaeId, "des");
    });
    this.$bus.$on("updateDadosResultado", data => {
      this.updateDadosResultado(data.id, data.dados);
    });
    this.$bus.$on("updateDadosComplemento", data => {
      this.updateComplemento(data.id, data.index, data.dados);
    });
    this.$bus.$on("updatePergunta", data => {
      this.updatePergunta(data.id, data.index, data.dados);
    });
    this.$bus.$on("updateBase", data => {
      this.updateBase(data.id, data.indexImposto, data.indexSt, data.dados);
    });
    this.$bus.$on("updateAliquotaEfetivaII", data => {
      this.updateAliquotaEfetivaII(data.id, data.indexImposto, data.aliquota);
    });
    this.$bus.$on("formularioInvalido", boolean => {
      this.formularioValido = boolean;
    });

    const user = this.getUsuario;
    this.fetchCenarios();

    this.resetCenariosPreenchidos();
  },
  mounted: function() {
    //Essa é para o 02
    $(window).scroll(function() {
      let scroll = $(window).scrollTop();

      if (scroll > 1845) {
        var px = $(window).scrollTop() - 1843;
        $(".dados-resumo-cenario").addClass("fixed-tudo");
        $(".btn-resumo-cenario").addClass("fixed-tudo");
        // $(".VueCarousel-slide .dados-resumo-cenario").css('transform', 'translate(0, ' + px + 'px)');
        $(".VueCarousel-slide .dados-resumo-cenario").addClass("fixed-tudo-slide");

        this.blExibeResumo = true;
      } else {
        $(".dados-resumo-cenario").removeClass("fixed-tudo");
        $(".btn-resumo-cenario").removeClass("fixed-tudo");
        // $(".VueCarousel-slide .dados-resumo-cenario").css('transform', 'translate(0, 0)');
        $(".VueCarousel-slide .dados-resumo-cenario").removeClass("fixed-tudo-slide");

        this.blExibeResumo = false;
      }
    });

    this.$watch(
      () => {
        if (this.$refs.carousel !== undefined && this.$refs.carouselResult !== undefined)
          return this.$refs.carousel.currentPage, this.$refs.carouselResult.currentPage;
      },
      val => {
        this.selecionaCenario(val + 1);
      }
    );
    if (
      localStorage.getItem("usuario_pro") == true ||
      localStorage.getItem("usuario_pro") == "true"
    ) {
      this.usuario_pro = 2;
    }

    this.fakeArNcmSelecionados = this.arNcmSelecionados;
    var ncms_selecionados = this.fakeArNcmSelecionados;
    var that = this;

    if (localStorage.getItem("arNcmProdutos"))
      this.arNcmProdutos = JSON.parse(localStorage.getItem("arNcmProdutos"));

    if (typeof this.arNcmProdutos !== "undefined" && this.arNcmProdutos.length > 0) {
      this.fakeArNcmSelecionados = this.arNcmProdutos;
      ncms_selecionados = this.fakeArNcmSelecionados;
    }
    this.arNcmSelecionados = ncms_selecionados;
  },
  watch: {
    blExibeResumo: function() {
      if (this.blExibeResumo) {
        this.moveTo("nodeToMove", "newParent");
        // $('#nodeToMove').moveTo('#newParent');
      }
    }
  },
  beforeDestroy() {
    //BUS REFATORACAO
    this.$bus.$off("limparImposto");
    this.$bus.$off("limpaBuffer");
    //FIM

    this.$bus.$off("exibirResumoCenario");
    this.$bus.$off("updateDadosResultado");
    this.$bus.$off("updateComplemento");
    this.$bus.$off("updatePergunta");
    this.$bus.$off("updateBase");
    this.$bus.$off("updateAliquotaEfetivaII");
    this.$bus.$off("abaAtiva");
    this.$bus.$off("forcePositionCarousel");
    this.$bus.$off("changeCnaeRemetente");
    this.$bus.$off("changeCnaeDestinatario");
    this.$bus.$off("formularioInvalido");
    this.$bus.$off("buscarResultado");
    this.$bus.$off("verificaValidacao");
    this.limpaChamadaBuffer();
  },
  computed: {
    ...mapGetters("resultado", ["getPossiveisAbasTodas"]),
    ...mapGetters("loading", {
      chamadasResultado: "getLoadingResultadosChamadas",
      getLoadingImpressao: "getLoadingImpressao"
    }),
    ...mapGetters("listaNcm", ["getArNcmSelecionados", "getTemporaryArNcmSelecionados"]),
    ...mapGetters("usuario", ["getUsuario"]),
    ...mapGetters("form", ["getDadosForm"]),
    ...mapGetters("resultado", ["getImpostos", "getPossiveisAbas"]),
    ...mapGetters("cenario", {
      blArrowsFixed: "getArrowScroll",
      getFormulariosValidos: "getFormulariosValidos",
      getIdFormularioErro: "getIdFormularioErro",
      getExibeArrows: "getExibeArrows",
      getDeleteCenario: "getDeleteCenario"
    }),
    ...mapGetters("modal", ["getModalImpressao"]),
    loadingResultado() {
      if (this.loadingResultadoCenario.some(p => p.loading == true) || this.exibeCarregando) {
        return true;
      }
      return false;
    },
    exibeVResultado() {
      if (this.getPossiveisAbasTodas.length == this.slides.length + 1) {
        return false;
      }
      return true;
    },
    arNcmSelecionados: {
      get() {
        const temporary = this.getTemporaryArNcmSelecionados;

        if (temporary.length > 0) {
          return temporary;
        }
        return this.getArNcmSelecionados;
      },
      set(newVal) {
        if (newVal) {
          this.setTemporaryArNcmSelecionados = newVal;
        }
      }
    },

    tipoIdUser: function() {
      let assinatura = JSON.parse(localStorage.getItem("assinatura"));

      return !assinatura ? false : assinatura.tipo_id;
    },

    liberaAntecipacao: function() {
      let tipoLiberacao = "todos";

      if (tipoLiberacao == "todos") {
        return true;
      }

      if (tipoLiberacao == "internos") {
        if (this.tipoIdUser == 100 || this.tipoIdUser == 1) {
          return true;
        }
        return false;
      }

      if (tipoLiberacao == "externos") {
        return this.tipoIdUser == 6 ? true : false;
      }
    },

    liberaDifal: function() {
      let tipoLiberacao = "todos";

      if (tipoLiberacao == "todos") {
        return true;
      }

      if (tipoLiberacao == "dev") {
        return this.tipoIdUser == 100 ? true : false;
      }

      if (tipoLiberacao == "econet") {
        if (this.tipoIdUser == 1 || this.tipoIdUser == 100) return true;
        else return false;
      }

      if (tipoLiberacao == "externos") {
        return this.tipoIdUser == 6 ? true : false;
      }
    }
  },
  methods: {
    voltar: function() {
      router.back();
    },
    openModalInvert() {
      this.setLoadTemporaryCenarios(false);
      this.blShow = !this.blShow;
      this.$bus.$emit("sobeCenario");
      this.$root.$emit("bv::show::modal", "ModalInvert");
    },

    // FUNÇÃO QUE ABRE MODAL DE IMPRESSÃO
    imprimirResultado() {
      this.modalImpressaoToggle = !this.modalImpressaoToggle;
    },
    selecionaSimilar(id, selecionado) {
      let idEncontrado = this.bssnSelecionado.find(f => f.id == id);
      if (idEncontrado) {
        idEncontrado.selecionado = selecionado;
      } else {
        this.bssnSelecionado.push({ id: id, selecionado: selecionado });
      }
    },
    limpaSimilar(id) {
      let limpaSimilar = this.bssnSelecionado.filter(f => f.id != id);
      this.bssnSelecionado = limpaSimilar;
    },
    getDadosModalBssn(id, dado) {
      this.bssnId = id;
      this.similarNacionalAliquota = dado;
    },
    modalSimilarToggle() {
      this.$nextTick(() => {
        this.modalSimilarAtivo = !this.modalSimilarAtivo;
      });
    },
    checaTodosFormularios(id, bool) {
      if (id == 1) {
        this.formValido.cenario1 = bool;
      }
      if (id == 2) {
        this.formValido.cenario2 = bool;
      }
      if (id == 3) {
        this.formValido.cenario3 = bool;
      }
    },
    modalSalvarCenario() {
      this.chamaSalvar = !this.chamaSalvar;
    },
    modalLimparCenario() {
      this.chamaLimpar = !this.chamaLimpar;
    },
    modalRemoverCenario() {
      this.chamaRemover = !this.chamaRemover;
    },
    ...mapActions("resultado", ["setLimpaPossiveisAbas"]),
    ...mapActions("listaNcm", ["setTemporaryArNcmSelecionados"]),
    ...mapActions("resultado", ["setImpostos", "setImpostosResultado", "setPossiveisAbas"]),
    ...mapActions("cenario", [
      "fetchCenarios",
      "setInvertCenarios",
      "setLoadTemporaryCenarios",
      "resetInvertCenarios",
      "removeTemporaryCenario",
      "deleteCenarioFalse",
      "resetListCenarios",
      "setFormulariosValidos",
      "resetCenariosPreenchidos"
    ]),
    setExibeResultado(bool) {
      this.exibeResultado = bool;
    },
    setExibeCarregando(bool) {
      this.exibeCarregando = bool;
    },
    preencheCnpj(id, origem, cnpj, idCnae) {

      if (origem == "remetente") {
        let encontra = this.cenarioCnpjRemetente.find(f => f.id == id);

        if (encontra) {
          encontra.cnpj = cnpj;
          this.cenarioCnpjRemetente = [];
          this.cenarioCnpjRemetente.push({ id: id, cnpj: cnpj, idCnae: idCnae });
        } else {
          this.cenarioCnpjRemetente.push({ id: id, cnpj: cnpj, idCnae: idCnae });
        }
      } else {
        let encontra = this.cenarioCnpjDestinatario.find(f => f.id == id);

        if (encontra) {
          encontra.cnpj = cnpj;
          this.cenarioCnpjDestinatario = [];
          this.cenarioCnpjDestinatario.push({ id: id, cnpj: cnpj, idCnae: idCnae });
        } else {
          this.cenarioCnpjDestinatario.push({ id: id, cnpj: cnpj, idCnae: idCnae });
        }
      }
    },
    impressaoSeleciona(dados) {
      this.impostoSelecionadoImpressao = dados;
    },

    adicionaDataCenario(data) {
      let findData = this.dataCenario.find(p => p.id == data.id);
      if (findData) {
        let newData = this.dataCenario.map(p => {
          if (p.id == data.id) {
            return data;
          }
          return p;
        });
        this.dataCenario = newData;
      } else {
        this.dataCenario.push(data);
      }
    },
    ...mapActions("modal", ["setModalInvertCenarios", "setModalImpressao"]),
    ...mapActions("alertas", ["fetchAlertas"]),
    ...mapActions("form", ["setDadosForm"]),
    ...mapActions("loading", ["setLoadingResultado"]),
    resumoHover(bool) {
      this.botaoResumoHover = bool;
    },
    trocaResumo() {
      this.mostraCamposC = !this.mostraCamposC;
      // if (this.mostraCamposC) {
      //   setTimeout(() => {
      //     this.$refs.blocoResultado.scrollIntoView({ behavior: "smooth" }, true);
      //   }, 300);
      // } else {
      //   setTimeout(() => {
      //     this.$refs.blocoCenario.scrollIntoView({ behavior: "smooth" }, true);
      //   }, 300);
      // }
    },
    calculaLoadingResultado(loading, id) {
      this.loadingResultadoCenario.map(p => {
        if (p.id == id) {
          p.loading = loading;
        }
      });
    },

    openImpressaoResultado: function() {
      this.$root.$emit("bv::hide::tooltip", "btn-impressao-open");
      this.setModalImpressao(true);
    },
    scrollToTop: function() {
      window.scrollTo(0, 0);
    },
    getDadosResultado: function(id) {
      this.dadosResultado[id] = this.getImpostos[id];
      return this.dadosResultado[id];
    },
    updateDadosResultado: function(id, impostos) {
      if (!impostos) {
        return;
      }

      let dados = this.dadosResultado;

      dados[id] = impostos;

      this.dadosResultado = dados;
    },
    updateComplemento: function(id, index, complemento) {
      if (!id || !index || !complemento) {
        return;
      }

      let dados = this.dadosResultado;

      if (!dados[id][index]) {
        return;
      }

      dados[id][index].complemento = complemento;

      this.dadosResultado = dados;
    },
    updatePergunta: function(id, index, perguntas) {
      if (id == null || id == undefined || index == null || index == undefined || !perguntas) {
        return;
      }

      let dados = this.dadosResultado;

      dados[id][index].perguntas = perguntas;

      this.dadosResultado = dados;
    },
    updateBase: function(id, indexImposto, indexSt, base) {
      if (
        id == null ||
        id == undefined ||
        indexImposto == null ||
        indexImposto == undefined ||
        indexImposto == null ||
        indexImposto == undefined ||
        !base
      ) {
        return;
      }

      let dados = this.dadosResultado;

      dados[id][indexImposto].st[indexSt].base = base;

      this.dadosResultado = dados;
    },
    updateAliquotaEfetivaII: function(id, indexImposto, aliquota) {
      if (id == null || id == undefined || indexImposto == null || indexImposto == undefined) {
        return;
      }

      let dados = this.dadosResultado;

      dados[id][indexImposto].aliquotaEfetivaII = aliquota;

      this.dadosResultado = dados;
    },
    leftArrow: function() {
      this.selecionaCenario(1, true);
    },
    rightArrow: function() {
      this.selecionaCenario(2, true);
    },
    atualizaST: function(bool) {
      this.mostrarST = bool;
    },
    atualizaSTArray: function(bool, position) {
      let arMostrar = this.arMostrarST;
      arMostrar[position] = bool;
      this.arMostrarST = arMostrar;
    },
    atualizaCest: function() {
      this.limparCest = !this.limparCest;
    },
    carregaCenarios: function() {
      return false;
      // this.slides = [];
      // this.lista_cenarios = [];
      // var that = this;
      // new Api().get("Usuario/obterUsuario").then(response => {
      //   var dados = response.dados;
      //   that.idUsuario = dados.id_usuario;
      //   new Api().get("Cenario/obterCenariosUsuario/" + dados.id_usuario).then(response => {
      //     var dados = response.dados;

      //     $.each(dados, function(index, element) {
      //       if (index != 0) {
      //         that.addCenarioDB(element);
      //       }

      //       if (index == 0) {
      //         that.cenarioPrincipal = element;
      //         that.cenarioPrincipal.firstCenario = 1;
      //       }
      //     });
      //   });
      // });
    },
    exibirResumoCenario: function(idCenario, idCenarioAlternativo, showResumo = false) {
      let that = this;
      let list = [];
      this.blExibeResumo = !this.blExibeResumo;
      if (showResumo) {
        if (this.blExibeResumo == false) {
          this.maximizarMinimizarChange(1);
        } else {
          this.maximizarMinimizarChange(2);
          this.calculaAlturaEspacoResumoDados();
        }
      } else {
        this.maximizarMinimizarChange(1);
      }

      this.exibeResumoCenario[1] = this.blExibeResumo;
      this.exibeResumoCenario[2] = this.blExibeResumo;
      this.exibeResumoCenario[3] = this.blExibeResumo;
      this.exibeResumoCenario[4] = this.blExibeResumo;
      let elmntToView = document.getElementById("btn-maluco");
      if (elmntToView != null) {
        $(".dados-resumo-cenario .calcula-dados-resumo").removeClass("fixed-tudo");
        $(".btn-resumo-cenario").removeClass("fixed-tudo");
        $(".VueCarousel-slide .dados-resumo-cenario").removeClass("fixed-tudo-slide");
        elmntToView.scrollIntoView();
      }
    },
    mudaResumoCenario: function(idCenario, idCenarioAlternativo, showResumo = false) {
      let that = this;
      let list = [];
      if (showResumo) {
        if (this.blExibeResumo == false) {
          this.maximizarMinimizarChange(1);
        } else {
          this.maximizarMinimizarChange(2);
          this.calculaAlturaEspacoResumoDados();
        }
      } else {
        this.maximizarMinimizarChange(1, true);
      }

      this.exibeResumoCenario[1] = this.blExibeResumo;
      this.exibeResumoCenario[2] = this.blExibeResumo;
      this.exibeResumoCenario[3] = this.blExibeResumo;
      this.exibeResumoCenario[4] = this.blExibeResumo;
      let elmntToView = document.getElementById("btn-maluco");
      if (elmntToView != null) {
        $(".dados-resumo-cenario .calcula-dados-resumo").removeClass("fixed-tudo");
        $(".btn-resumo-cenario").removeClass("fixed-tudo");
        $(".VueCarousel-slide .dados-resumo-cenario").removeClass("fixed-tudo-slide");
        elmntToView.scrollIntoView();
      }
    },
    addCenarioDB: function(element = null) {
      var _selecionado = false;
      var _lista_length = this.lista_cenarios.length;
      if (_lista_length == 0) {
        _selecionado = true;
      }
      if (_lista_length < 2) {
        this.slides.push({
          id: _lista_length + 1,
          elemento: element
        });
        this.lista_cenarios.push({
          cenario: parseInt(_lista_length + 1),
          selecionado: _selecionado,
          elemento: element
        });
        this.$refs.carouselResult.goToPage(_lista_length);
        this.$refs.carousel.goToPage(_lista_length);
      }
    },
    ativaAba: function(dados) {
      let exibeAba = this.getPossiveisAbas.indexOf(dados) > -1;
      // var exibeAba = JSON.stringify(this.getImpostos).indexOf('"' + dados + '"') > -1;
      // if (this.abaAtiva == '' && exibeAba && this.abaAtiva == 'valida_equiparacao_industrial') {
      // 	this.abaAtiva = dados;
      //  	this.controleAbas(dados);
      // }
      // if (dados == 'icms_interno') {
      // 	this.possuiAbasAtivas = false;
      // }
      // if (!this.possuiAbasAtivas) {
      // 	this.possuiAbasAtivas = exibeAba;
      // }
      return exibeAba;
    },
    recuperaDadosResultadoCenario: function(dados, id) {
      let totalImpostos = 0;
      let dadosResumoCenario = this.dadosResumoCenario;
      $.each(dados.impostos, function() {
        totalImpostos++;
      });

      if (totalImpostos > 0) {
        var item = id.replace("Cenario", "");
        this.blSN = dados.blSN;

        dadosResumoCenario[item] = {
          nome: dados.nomeCenario,
          termo: dados.termo_pesquisado,
          ncm: dados.ncm_tipi,
          local: dados.selected_local.label,
          estado_origem: dados.selected_estado_origem.label,
          estado_destino: dados.selected_estado_destino.label,
          pais_origem: dados.selected_pais_origem.label,
          pais_destino: dados.selected_pais_destino.label,
          atividade_destinatario:
            dados.selected_destinatario_pergunta.value === "1"
              ? dados.selected_cnae.label
              : dados.selected_atividade_destinatario.label,
          atividade_remetente: dados.selected_atividade.label,
          origem_mercadoria: dados.selected_origem_mercadoria.label,
          destinacao: dados.selected_destinacao.label,
          descrTipi: dados.descricao_tipi,
          descricao:
            typeof dados.selected_ncm[0] !== "undefined"
              ? dados.selected_ncm[0].label.replace(dados.selected_ncm[0].value + " - ", "")
              : dados.selected_ncm.label.replace(dados.selected_ncm.value + " - ", "")
        };

        this.dadosResultado[item] = dados.impostos;
        this.setImpostos({ id: item, imposto: dados.impostos });
        // this.addImpostosFAKE(dados.impostos, item);
        this.ativaAba("icms_interno");
        this.ativaAba("preferencia_tarifaria");
        this.ativaAba("exportacao");
        this.ativaAba("class_importacao");
        this.ativaAba("defesa_comercial");
        this.ativaAba("cide_combustivel");
        this.ativaAba("pis_cofins");
        this.ativaAba("ipi");
        this.ativaAba("carga_liquida");
        this.ativaAba("antecipacao");
        this.ativaAba("difal");

        if (!this.abaAtiva) {
          this.abaAtiva = this.dadosResultado[item][0]["classe"];
        }

        this.controleAbas(this.abaAtiva);
        this.$forceUpdate();
      } else {
        var item = id.replace("Cenario", "");
        this.dadosResultado[item] = dados.impostos;
        this.setImpostos({ id: item, imposto: dados.impostos });
        // this.addImpostosFAKE(dados.impostos, item);
        this.$forceUpdate();
      }
      this.ativaDesativaLoading(false);
      this.dadosResumoCenario = dadosResumoCenario;
    },
    ativaDesativaLoading: function(value) {
      if (this.chamadasResultado > 0 && !value) {
        return;
      }

      // if (this.$refs.resultado) {
      //   this.$refs.resultado.setLoadingPerguntas(value);
      // }
      // if (this.$refs.resultado2) {
      //   this.$refs.resultado2.forEach(function(item, key) {
      //     item.setLoadingPerguntas(value);
      //   });
      // }
    },
    addImpostosFAKE: function(dados, id) {
      /*if (dados.length == 0 ) {
				this.impostosFAKE[id] = [];
			} else {*/

      this.impostosFAKE[id] = [];
      var tributos = this.tributosFAKE;
      var tributosFiltrados = [];
      $.each(tributos, function(key, elem) {
        var blExiste = JSON.stringify(dados).indexOf(elem.classe) > -1;
        if (!blExiste) {
          tributosFiltrados.push(elem);
        } else if (elem.classe == "carga_liquida") {
          tributosFiltrados.push(elem);
        }
      });

      this.impostosFAKE[id] = tributosFiltrados;
      //}
    },
    addCenario: function() {
      this.$root.$emit("bv::show::modal", `ModalDuplicarCenario1`, "#btnShow");

      this.numeroNomeCenario += 1;
      this.blExibeResultado = false;
      this.exibirResumoCenario(0, 0, false);
      this.intLastIdCenario++;
      var _selecionado = false;
      this.$nextTick(() => {
        let idCenario = this.numeroNomeCenario;
        _selecionado = true;

        if (this.lista_cenarios.length < 2) {
          var fakeElemento = {
            id: idCenario,
            nome_cenario: "Cenário " + (this.intLastIdCenario + 1)
          };
          this.slides.push({
            id: idCenario,
            elemento: fakeElemento
          });
          this.lista_cenarios.push({
            cenario: idCenario,
            selecionado: _selecionado,
            elemento: fakeElemento
          });
          if (this.slides.length == 2) {
            this.$nextTick(() => {
              this.selecionaCenario(2);
            });
          }
        }
      });
    },
    inverterCenario: function() {
      // this.deleteCenarioFalse();
      this.setLoadTemporaryCenarios(false);
      this.$bus.$emit("sobeCenario");
      this.setModalInvertCenarios(true);
    },
    teste() {
      console.log("lista_cenarios->", this.lista_cenarios);
      console.log("slides->", this.slides);
      this.selecionaCenario(2);
    },
    removeCenario: function(idCenario) {
      let listaCenarios = this.lista_cenarios.filter(f => {
        if (f.cenario == idCenario) {
          return false;
        }
        return true;
      });
      this.lista_cenarios = listaCenarios;
      let listaSlides = this.slides.filter(f => {
        if (f.id == idCenario) {
          return false;
        }
        return true;
      });

      this.slides = listaSlides;
      if (this.lista_cenarios.length > 0) {
        let tempLista = this.lista_cenarios;
        tempLista = tempLista.filter((e, index) => {
          if (index == 0) {
            e.selecionado = true;
          }
          return true;
        });
        this.lista_cenarios = tempLista;
      }
    },
    removerCenarioComparacao: function(idCenario) {
      this.removeCenario(idCenario);
      this.exibirResumoCenario(0, 0, false);

      this.removeTemporaryCenario(idCenario);
      this.blExibeResultado = false;

      return false;
    },
    forcePositionCarousel: function(page) {
      let position = 0;
      let list = this.lista_cenarios.filter((e, index) => {
        if (e.cenario == page) {
          position = index;
        }
      });

      position += 1;

      this.$nextTick(function() {
        this.selecionaCenario(page);
      });
    },
    selecionaCenario: function(posicao, arrowButton = false) {
      var _cenario = this.lista_cenarios;
      var that = this;

      // if (arrowButton) {
      //   this.mudaResumoCenario(0, 0, false);
      // } else {
      //   this.exibirResumoCenario(0, 0, false);
      // }

      $.each(_cenario, function(key, elem) {
        that.lista_cenarios[key]["selecionado"] = false;
      });

      if (this.lista_cenarios[parseInt(posicao - 1)] !== undefined) {
        this.lista_cenarios[parseInt(posicao - 1)]["selecionado"] = true;
        this.$refs.carouselResult.goToPage(posicao - 1);

        if (this.$refs.carousel) {
          this.$refs.carousel.goToPage(posicao - 1);
          // this.$refs.carousel.goToPage(posicao - 1);
        }

        this.manipularDados(posicao, "select");

        if (this.lista_cenarios.length > 0) {
          let tempLista = this.lista_cenarios;
          tempLista = tempLista.filter((e, index) => {
            if (index == parseInt(posicao - 1)) {
              e.selecionado = true;
            } else {
              e.selecionado = false;
            }
            return true;
          });
          this.lista_cenarios = tempLista;
        }
      }

      this.idCenarioSelecionado = posicao;
    },

    buscarImposto: async function({ imposto, idCenario }) {
      // try {
      const opcoesUrl = {
        class_importacao: "Cenario/obterImpostoImportacao",
        exportacao: "Cenario/obterImpostoExportacao",
        preferencia_tarifaria: "Cenario/obterImpostoPreferenciaTarifaria",
        defesa_comercial: "Cenario/obterImpostoDefesaComercial",
        ipi: "Cenario/obterPerguntasIpi",
        ipi_respostas: "Cenario/obterImpostoIpi",
        pis_cofins: "Cenario/obterImpostoPisCofins",
        cide_combustivel: "Cenario/obterImpostoCideCombustivel",
        icms_interno: "Cenario/obterImpostoIcms",
        icms_st: "Cenario/obterPerguntasIcmsSt",
        carga_liquida: "Cenario/obterPerguntasCargaLiquida",
        antecipacao: "Cenario/obterPerguntasAntecipacao",
        difal: "Cenario/obterPerguntasDifal"
      };

      const resposta =
        // imposto == "ipi_respostas"
        //   ?
        await this.chamadaRotaImpostos(opcoesUrl[imposto], this.getDadosForm[idCenario], imposto);
      // : await new Api().post(opcoesUrl[imposto], this.getDadosForm[idCenario]);

      // REMOVIDO POIS ESTAVA CHAMANDO IPI 2X, VERIFICAR SE GERA BUG
      // if (imposto == "ipi") {
      //   const dadosIpi = await this.tratamentoDadosIpi(resposta.dados[0].perguntas, idCenario);
      //   resposta.dados = !!dadosIpi ? dadosIpi : resposta.dados;
      // }

      this.$forceUpdate();
      return resposta.dados;
      // } catch (err) {
      //   console.log(err);
      // }
    },
    tratamentoDadosIpi: async function(perguntas, id) {
      if (perguntas.length == 1) {
        let form = this.getDadosForm[id];
        form.regra = perguntas[0].id_regra;
        // this.setDadosForm({id:1, dadosForm: form})
        const response = await new Api().post("Cenario/obterImpostoIpi", form);
        // const response = await this.chamadaRota('Cenario/obterImpostoIpi', form)

        return response.dados;
      }
    },
    verificaImpostosChamados: function(imposto) {
      const jaChamado = this.impostosChamados.indexOf(imposto);

      if (jaChamado > -1) return true;

      this.impostosChamados.push(imposto);
      return false;
    },

    limpaImpostosChamados: function(imposto) {
      this.impostosChamados = this.impostosChamados.filter(imp => imp != imposto);
    },
    controleAbas: function(el, removeAltura = false, seleciona = false) {
      if (this.loadingResultado) {
        return;
      }
      let that = this;

      if (el === "icms_st") {
        $(".duplo .box-" + el + "_st").css("height", "auto");
      }

      if (removeAltura) {
        setTimeout(function() {
          // $('.duplo .box-' + el).css('height', '210px');
          // setTimeout(function () {

          if (el == "antecipacao" || el == "icms") {
            $(".box-antecipacao-alertas").css("height", "auto");
            $(".box-antecipacao-alertas").css("min-height", "auto");
            $(".box-antecipacao-icms").css("height", "auto");
            $(".box-antecipacao-previa").css("height", "auto");
            $(".box-antecipacao-beneficios").css("height", "auto");
            $(".box-antecipacao-antecipacao").css("height", "auto");
            $(".box-antecipacao-fundos").css("height", "auto");
            return;
          }

          if (el == "difal" || el == "icms") {
            $(".box-difal-alertas").css("height", "auto");
            $(".box-difal-alertas").css("min-height", "auto");
            $(".box-difal-icms").css("height", "auto");
            $(".box-difal-previa").css("height", "auto");
            $(".box-difal-beneficios").css("height", "auto");
            $(".box-difal-difal").css("height", "auto");
            $(".box-difal-fundos").css("height", "auto");
          }

          $(".duplo .box-" + el).css("height", "auto");

          if (el == "carga_liquida") {
            $(".duplo .box-valida-" + el).css("height", "auto");
            $(".duplo .box-icms-" + el).css("height", "auto");
            $(".duplo .box-previa-" + el).css("height", "auto");
            $(".duplo .box-final-" + el).css("height", "auto");
            $(".duplo .box-required-" + el).css("height", "auto");
            $(".duplo .box-loading-" + el).css("height", "auto");
            $(".duplo .box-alerta-" + el).css("height", "auto");
          }

          // BENEFICIOS
          setTimeout(function() {
            if (el === "icms_interno" || el === "icms_st") {
              $(".duplo .box-" + el + "_beneficios").css("height", "auto");

              var maxHeightBeneficio = 0;
              $.each($(".bloco-resultado .duplo .box-resultado.box-beneficio"), function(
                key,
                elem
              ) {
                maxHeightBeneficio =
                  maxHeightBeneficio < elem.offsetHeight ? elem.offsetHeight : maxHeightBeneficio;
              });
              $(".duplo .box-" + el + "_beneficios").css("height", maxHeightBeneficio);
            } else if (el == "pis_cofins") {
              $(".div-content-pis_cofins").css("height", "auto");
            }
          }, 200);
        }, 100);
      } else {
        if (!this.abaAtiva || seleciona) {
          this.abaAtiva = el ? el : this.abaAtiva;
        }

        setTimeout(function() {
          var heightAtual = localStorage.getItem("heightAtual");

          if (el == "antecipacao" || el == "icms") {
            that.calculaAlturaAntecipacao(el);
            return;
          }

          if (el == "difal" || el == "icms") {
            that.calculaAlturaDifal(el);
            return;
          }

          $(".duplo .box-" + el).css("height", "auto");

          if (el === "icms_interno" || el === "icms_st") {
            var classTeste = "";
            var idComFundo = 0;
            if (el === "icms_interno") {
              $.each($(".bloco-resultado .duplo .box-resultado.box-fundo_" + el), function(
                key,
                elem
              ) {
                classTeste = ".div-content-resultado";
                idComFundo = $(elem)[0].id;
              });
            }

            if (el === "icms_st") {
              $.each($(".bloco-resultado .duplo .box-resultado.box-" + el + "_fundo"), function(
                key,
                elem
              ) {
                classTeste = ".div-content-resultado";
                idComFundo = $(elem)[0].id;
              });
            }

            var maxHeight = 0;
            var ids = [];
            $.each(
              $(".bloco-resultado .duplo " + classTeste + " .box-resultado.box-" + el),
              function(key, elem) {
                maxHeight = maxHeight < elem.offsetHeight ? elem.offsetHeight : maxHeight;
                ids.push($(elem)[0].id);
              }
            );
            $(".duplo " + classTeste + " .box-" + el).css("height", maxHeight);
            $(".duplo .box-" + el).css("height", maxHeight);
            // FUNDO ICMS
            var maxHeightFundo = 0;
            if (el === "icms_interno") {
              $.each(
                $(".bloco-resultado .duplo " + classTeste + " .box-resultado.box-fundo_" + el),
                function(key, elem) {
                  maxHeightFundo =
                    maxHeightFundo < elem.offsetHeight ? elem.offsetHeight : maxHeightFundo;
                }
              );

              // box select fundo_
              var maxHeightFundoSelect = 0;
              $.each(
                $(".bloco-resultado .duplo " + classTeste + " .box-select-fundo-icms_interno"),
                function(key, elem) {
                  maxHeightFundoSelect =
                    maxHeightFundoSelect < elem.offsetHeight
                      ? elem.offsetHeight
                      : maxHeightFundoSelect;
                }
              );

              if (maxHeightFundoSelect > maxHeightFundo) {
                maxHeightFundoSelect += 19;

                $(".duplo .div-content-resultado .icms_interno_fundo").css("height", "auto");
                $(".duplo " + classTeste + " .box-fundo_" + el).css(
                  "min-height",
                  maxHeightFundoSelect
                );
                $(".duplo .div-content-resultado.fundo_icms_interno").css(
                  "min-height",
                  maxHeightFundoSelect
                );
              } else {
                $(".duplo .div-content-resultado .icms_interno_fundo").css("height", "auto");
                $(".duplo " + classTeste + " .box-fundo_" + el).css("min-height", maxHeightFundo);
                $(".duplo .div-content-resultado.fundo_icms_interno").css(
                  "min-height",
                  maxHeightFundo
                );
              }
            }

            // FUNDO ICMS ST
            if (el === "icms_st") {
              $(".duplo .box-" + el + "_fundo").css("height", "auto");

              $.each(
                $(".bloco-resultado .duplo " + classTeste + " .box-resultado.box-" + el + "_fundo"),
                function(key, elem) {
                  maxHeightFundo =
                    maxHeightFundo < elem.offsetHeight ? elem.offsetHeight : maxHeightFundo;
                }
              );

              let maxHeightICSt = 0;
              $.each($(".box-icms_st"), function(key, elem) {
                maxHeightICSt =
                  maxHeightICSt < elem.offsetHeight ? elem.offsetHeight : maxHeightICSt;
              });

              $(".duplo " + classTeste + " .box-" + el + "_fundo").css("height", maxHeightFundo);
              $(".duplo " + classTeste + " .icms_st_fundo").css("height", maxHeightFundo);
              $(".duplo .box-icms_interno_st").css("height", maxHeightICSt);
            }

            // BENEFICIOS
            var maxHeightBeneficio = 0;
            $.each(
              $(".bloco-resultado .duplo " + classTeste + " .box-resultado.box-beneficio"),
              function(key, elem) {
                maxHeightBeneficio =
                  maxHeightBeneficio < elem.offsetHeight ? elem.offsetHeight : maxHeightBeneficio;
              }
            );
            $(".duplo " + classTeste + " .box-" + el + "_beneficios").css(
              "height",
              maxHeightBeneficio
            );
            //

            // ST da ST
            if (el === "icms_st") {
              let maxHeightSt = 0;
              $.each($(".box-icms_st_st"), function(key, elem) {
                maxHeightSt = maxHeightSt < elem.offsetHeight ? elem.offsetHeight : maxHeightSt;
              });
              $(".duplo " + classTeste + " .box-" + el + "_st").css("height", maxHeightSt);
            }

            ids.splice($.inArray(idComFundo, ids), 1);
            if (classTeste != "") {
              $(".duplo .div-resultado-fake .box-" + el).css("height", maxHeightFundo + maxHeight);
            }
          } else {
            var maxHeight = 0;
            $.each($(".bloco-resultado .duplo .box-resultado"), function(key, elem) {
              maxHeight = maxHeight < elem.offsetHeight ? elem.offsetHeight : maxHeight;
            });

            if (el === "class_importacao") {
              maxHeight += 5;
            }

            localStorage.setItem("heightAtual", maxHeight);
            that.verificarLSIsNull("heightAtual");

            $(".duplo .box-" + el).css("height", heightAtual);
            $(".duplo .box-" + el).css("height", maxHeight);

            if (el == "pis_cofins") {
              $(".duplo .box-" + el).css("height", maxHeight);
            }
          }

          if (el == "carga_liquida") {
            that.calculaAltura(".box-valida-" + el);
            that.calculaAltura(".box-icms-" + el);
            that.calculaAltura(".box-previa-" + el);
            that.calculaAltura(".box-final-" + el);
            that.calculaAltura(".box-required-" + el);
            that.calculaAltura(".box-alerta-" + el);
            that.calculaAltura(".box-loading-" + el);
          }
        }, 100);
      }

      if (el == "pis_cofins") {
        that.calculaAlturaPisConfis(el);
      }
      that.calculaAlturaAlertas(el);
    },

    calculaAlturaAntecipacao: function(el) {
      let that = this;

      that.calculaAltura(".box-antecipacao-alertas");
      that.calculaAltura(".box-antecipacao-icms");
      that.calculaAltura(".box-antecipacao-previa");
      that.calculaAltura(".box-antecipacao-beneficios");
      that.calculaAltura(".box-antecipacao-antecipacao");
      that.calculaAltura(".box-antecipacao-fundos");
    },

    calculaAlturaDifal: function(el) {
      let that = this;

      that.calculaAltura(".box-difal-alertas");
      that.calculaAltura(".box-difal-icms");
      that.calculaAltura(".box-difal-previa");
      that.calculaAltura(".box-difal-beneficios");
      that.calculaAltura(".box-difal-difal");
      that.calculaAltura(".box-difal-fundos");
    },

    calculaAlturaAlertas: function(classe) {
      let maxHeight = 0;

      setTimeout(function() {
        $(".duplo .box-alerta-atualizacao .box-" + classe).css("height", "auto");

        $.each($(".bloco-resultado .duplo .box-alerta-atualizacao.box-" + classe), function(
          key,
          elem
        ) {
          maxHeight = maxHeight < elem.offsetHeight ? elem.offsetHeight : maxHeight;
        });

        $(".duplo .box-alerta-atualizacao.box-" + classe).css("height", maxHeight);
      }, 100);
    },
    calculaAlturaPisConfis: function(classe) {
      let maxHeight = 0;

      setTimeout(function() {
        $(".duplo .box-resultado.box-" + classe).css("height", "auto");
        $.each($(".bloco-resultado .duplo .box-resultado.box-" + classe), function(key, elem) {
          maxHeight = maxHeight < elem.offsetHeight ? elem.offsetHeight : maxHeight;
        });
        $(".duplo .box-resultado.box-" + classe).css("height", maxHeight);
      }, 100);
    },
    calculaAltura: function(classe) {
      let maxHeight = 0;

      $(".duplo " + classe).css("height", "auto");

      $.each($(".bloco-resultado .duplo " + classe), function(key, elem) {
        maxHeight = maxHeight < elem.offsetHeight ? elem.offsetHeight : maxHeight;
      });

      if (classe.indexOf("antecipacao") > -1) {
        $(".duplo " + classe).css("height", maxHeight);
      } else {
        $(".duplo .box-" + classe).css("height", maxHeight);
      }
    },
    calculaAlturaEspacoResumoDados: function() {
      let maxHeight = 0;
      setTimeout(function() {
        $(".calcula-dados-resumo").css("height", "auto");
        $.each($(".calcula-dados-resumo"), function(key, elem) {
          maxHeight = maxHeight < elem.offsetHeight ? elem.offsetHeight : maxHeight;
        });
        $(".calcula-dados-resumo").css("height", maxHeight);
      }, 100);
    },

    possuiErrosForm: function() {
      this.$bus.$emit("validarFormulario");

      if (this.formularioValido) {
        return false;
      }
      return true;
    },

    maximizarMinimizarChange: function(valor, arrow = false) {
      this.mostraCamposC = true;
      if (valor == 2) {
        this.mostraCamposC = false;
        this.btn_maximixar = true;
        this.btn_minimizar = false;
      } else {
        if (this.blExibeResumo == true && arrow) {
          this.mudaResumoCenario(0, 0, true);
          return;
        } else if (this.blExibeResumo == true && !arrow) {
          this.exibirResumoCenario(0, 0, false);
        }
        this.btn_maximixar = false;
        this.btn_minimizar = true;
      }
    },
    verificaCNPJ(id, cnpj, origem, cenario = false) {
      // Busca CNAEs diretamente sem usar captcha da Receita
      this.buscarCnaesEcoHub(id, cnpj, origem);
    },
    buscarCnaesEcoHub(id, cnpj, origem) {
      // Mostra modal de carregamento
      this.idModalCaptcha = id;
      this.cnpjModalCaptcha = cnpj;
      // Força a abertura do modal com loading ativo
      this.$refs.refCaptcha.verificaCNPJ(id, origem, true);
    },
    setCnaeCnpj: function(arDados) {
      if (this.idModalCaptcha == "Cenario1") this.$refs[this.idModalCaptcha].setCnaeCnpj(arDados);
      else this.$refs[this.idModalCaptcha][0].setCnaeCnpj(arDados);
    },
    reset: function(id, nivel) {
      if (nivel == 1) this.VCenarioKey[id]++;

      if (nivel == 3) {
        this.VCenarioKey[id]++;

        // this.$forceUpdate();
      }
    },
    resetInicio: function(id, idCenario) {
      let key = parseInt(id.substring(7));

      //Nivel 1
      if (id.replace("Cenario", "") == 1) this.reset(id.replace("Cenario", ""), 1);
      //Nivel 3
      if (id.replace("Cenario", "") > 1) {
        this.reset(id.replace("Cenario", ""), 3);
      }

      this.dadosResultado[key] = [];
      this.setImpostos({ id: key, imposto: [] });
      this.impostosFAKE[key] = [];

      // if (idCenario > 0) {
      // 	new Api().get('Cenario/resetCenarioUsuario/' + idCenario).then(response => {});
      // 	this.carregaCenarios();
      // }

      this.blBtnLimpar = true;
    },
    passarId: function(id, idCenario) {
      this.idSelecionado = id;
      this.idCenarioReset = idCenario;
    },
    passarIdCenario: function(idCenario) {
      this.idCenarioSelecionado = idCenario;
    },
    reportaChecks: function(idCenario, qtdeChecks) {
      this.$set(this.arChecks, idCenario, qtdeChecks);
      this.validaImpressao(idCenario);
    },
    registraCheck: function(idCenario, name = "") {
      let ar = this.arChecksSelected;
      ar[idCenario] = {
        [name]: "1"
      };
      ar[idCenario][name] = "1";

      this.$set(this.arChecksSelected, idCenario, ar[idCenario]);
      this.validaImpressao(idCenario);
    },
    reportaChecksFundo: function(idCenario, qtdeChecks) {
      this.$set(this.arChecksFundo, idCenario, qtdeChecks);
      this.validaImpressao(idCenario);
    },
    registraCheckFundo: function(idCenario, name = "") {
      let ar = this.arChecksSelectedFundo;
      ar[idCenario] = {
        [name]: "1"
      };
      ar[idCenario][name] = "1";

      this.$set(this.arChecksSelectedFundo, idCenario, ar[idCenario]);
      this.validaImpressao(idCenario);
    },
    resetaCheck: function(idCenario) {
      this.arChecksSelected.splice(idCenario, 1);
    },
    validaImpressao: function(idCenario) {
      let qtdeChecks = this.arChecks[idCenario];
      let qtdeChecksFundo = this.arChecksFundo[idCenario];
      let qtdeChecked = 0;
      let qtdeCheckedFundo = 0;

      if (typeof this.arChecksSelected[idCenario] !== "undefined") {
        this.arChecksSelected.map((ar, i) => {
          if (i === idCenario) {
            qtdeChecked++;
          }
        });
      }

      if (typeof this.arChecksSelectedFundo[idCenario] !== "undefined") {
        this.arChecksSelectedFundo.map((ar, i) => {
          if (i === idCenario) {
            qtdeCheckedFundo++;
          }
        });
      }
      if (qtdeChecks == qtdeChecked && qtdeChecksFundo == qtdeCheckedFundo) {
        //console.log("OK. Esta liberado para imprimir", "qtdeChecks: " + qtdeChecks + " qtdeChecked: " + qtdeChecked);
        this.$set(this.blImprimir, idCenario, true);
      } else {
        //console.log("ERRO. Não esta liberado para imprimir", "qtdeChecks: " + qtdeChecks + " qtdeChecked: " + qtdeChecked);
        this.$set(this.blImprimir, idCenario, false);
      }
    },
    registraRadioImpressao: function(indexImposto, index, id) {
      if (typeof this.arSelectRadio[id] == "undefined") {
        this.arSelectRadio[id] = [];
      }
      this.arSelectRadio[id][indexImposto] = index;
    },
    registraRadioFundoImpressao: function(indexFundo, index, id, fundo) {
      if (fundo) {
        if (typeof this.arSelectFundo[id] == "undefined") {
          this.arSelectFundo[id] = [];
          this.fundoSelecionado = null;
        }
        this.arSelectFundo[id][indexFundo] = index;
        this.fundoSelecionado = fundo;
      } else {
        this.fundoSelecionado = null;
      }
    },
    getRadioFundoImpressao: function() {
      return this.fundoSelecionado;
    },
    inArray: function(needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    },
    manipularDados(posicao, origem) {
      let cenario1 = this.dadosResultado[1] ? this.dadosResultado[1] : [];
      let cenarioC =
        posicao + 1 > 1
          ? this.dadosResultado[posicao + 1]
            ? this.dadosResultado[posicao + 1]
            : []
          : [];

      let arClasses1 = [];
      let arClassesC = [];
      let arAbasResultado = [];
      let abaAtiva = [];
      let arHide = [];
      let arShow = [];
      let arAbas = [];

      let redirect = true;

      let classToAba = {
        0: {
          icms_interno: "ICMS",
          preferencia_tarifaria: "PREFERÊNCIA TARIFÁRIA",
          exportacao: "IE",
          class_importacao: "II",
          defesa_comercial: "DEFESA COMERCIAL",
          cide_combustivel: "CIDE COMBUSTÍVEL",
          acordo_comercial: "ACORDO COMERCIAL",
          ipi: "IPI",
          pis_cofins: "PIS COFINS",
          carga_liquida: "ICMS CARGA LÍQUIDA",
          antecipacao: "ICMS ANTECIPAÇÃO",
          difal: "ICMS DIFAL"
        },
        1: {
          ICMS: "icms_interno",
          "PREFERÊNCIA TARIFÁRIA": "preferencia_tarifaria",
          IE: "exportacao",
          II: "class_importacao",
          "DEFESA COMERCIAL": "defesa_comercial",
          "CIDE COMBUSTÍVEL": "cide_combustivel",
          "ACORDO COMERCIAL": "acordo_comercial",
          IPI: "ipi",
          "PIS COFINS": "pis_cofins",
          carga_liquida: "carga_liquida",
          antecipacao: "antecipacao",
          difal: "difal"
        },
        2: {
          icms_interno: "abaICMS",
          preferencia_tarifaria: "abaPreferenciaTarifaria",
          exportacao: "abaExportacao",
          class_importacao: "abaImportacao",
          defesa_comercial: "abaDefesa",
          cide_combustivel: "abaCIDE",
          acordo_comercial: "abaAcordo",
          ipi: "abaIPI",
          pis_cofins: "abaPISCOFINS",
          carga_liquida: "abaCargaLiquida",
          antecipacao: "abaAntecipacao",
          difal: "abaDifal"
        }
      };

      if (cenario1.length > 0 && cenarioC.length > 0) {
        let elementList = document.querySelectorAll(".abas span");

        for (let i = 0; i < elementList.length; i++) {
          if (elementList[i].classList.contains("ativo")) {
            abaAtiva = elementList[i].innerHTML;
          }
          if (elementList[i].style.display != "none") {
            arAbasResultado.push(elementList[i].innerHTML);
          }
        }

        for (let i = 0; i < cenario1.length; i++) {
          arClasses1.push(classToAba[0][cenario1[i].classe]);
        }

        for (let i = 0; i < cenarioC.length; i++) {
          arClassesC.push(classToAba[0][cenarioC[i].classe]);
        }

        for (let i = 0; i < arAbasResultado.length; i++) {
          if (
            this.inArray(arAbasResultado[i], arClasses1) ||
            this.inArray(arAbasResultado[i], arClassesC)
          ) {
            arShow.push(classToAba[1][arAbasResultado[i]]);
          } else {
            arHide.push(classToAba[1][arAbasResultado[i]]);
          }
        }

        arClasses1.concat(arClassesC).map(item => {
          arAbas.push(classToAba[1][item]);
        });

        arAbas.map(item => {
          $(`.abas .${classToAba[2][item]}`).removeAttr("style");
        });

        arShow.map(item => {
          if (this.abaAtiva == item) {
            if (!$(`.div-content-${item}`).hasClass("div-resultado-fake")) {
              $(`.div-content-${item} .box-${item}`).removeAttr("style");
            }
          }
        });

        arHide.map(item => {
          if (item == this.abaAtiva) {
            this.controleAbas(arShow[0]);
            redirect = false;
          }
          $(`.abas .${classToAba[2][item]}`).attr("style", "display:none");
        });

        if (redirect) {
          this.controleAbas(classToAba[1][arAbasResultado[0]]);
        }

        if (origem == "save") {
          if (posicao + 1 > 2) this.selecionaCenario(posicao);
        }
      }

      if (
        (cenario1.length > 0 && cenarioC.length == 0) ||
        (cenario1.length == 0 && cenarioC.length > 0)
      ) {
        let elementList = document.querySelectorAll(".abas span");

        for (let i = 0; i < elementList.length; i++) {
          if (elementList[i].classList.contains("ativo")) {
            abaAtiva = elementList[i].innerHTML;
          }
          if (elementList[i].style.display != "none") {
            arAbasResultado.push(elementList[i].innerHTML);
          }
        }
        this.controleAbas(classToAba[1][arAbasResultado[0]]);

        if (origem == "save") {
          if (posicao + 1 > 2) this.selecionaCenario(posicao);
        }
      }
    },
    reloadData(status) {
      let primeiraAba = "";
      if (this.getPossiveisAbas.length > 0) {
        primeiraAba = this.getPossiveisAbas[0].toLowerCase();
      }

      primeiraAba = primeiraAba == "imposto_exportacao" ? "exportacao" : primeiraAba;
      primeiraAba = primeiraAba == "imposto_importacao" ? "class_importacao" : primeiraAba;

      if (status == "removerLoading") {
        this.abaAtiva = null;
        this.loading = false;
        this.blExibeResultado = false;
        return;
      }

      if (status == "resultado") {
        this.abaAtiva = primeiraAba;
        this.loading = false;
        this.blExibeResultado = true;
        this.impostosChamados = [];
        this.verificaImpostosChamados(primeiraAba);
      }
      if (status == null) {
        this.abaAtiva = status;
        this.loading = true;
        this.blExibeResultado = true;
        return;
      }

      if (status == "removerErros") {
        this.erroResultado = false;
        return;
      }

      if (status == "error") {
        this.loading = false;
        this.erroResultado = true;
        this.blExibeResultado = false;
        return;
      }

      // this.loading = false;
      // this.lista_cenarios.map(item => {
      // 	if (item.selecionado) {
      // 		posicao = item.cenario;
      // 	}
      // });

      let qtdCenarios = this.lista_cenarios.length + 1;
      this.intContadorResultados++;

      if (this.intContadorResultados == qtdCenarios && qtdCenarios > 0) {
        this.intContadorResultados = 0;
        let isto = this;

        setTimeout(function() {
          isto.loading = false;
          isto.$forceUpdate();
        }, 2000);
      }
    },

    btnObterResultados: function() {
      this.setLimpaPossiveisAbas();
      let valido = Object.entries(this.formValido).filter(([_, value]) => value == true).length;
      if (valido != this.slides.length + 1) {
        if (!this.formValido.cenario2 && !this.formValido.cenario3) {
        } else if (!this.formValido.cenario2) {
          this.selecionaCenario(1);
        } else if (!this.formValido.cenario3) {
          this.selecionaCenario(2);
        }
        this.$bus.$emit("verificaValidacao");
        this.$nextTick(() => {
          this.pushAlert("É necessário preencher os campos obrigatórios!", "danger");
        });
      } else {
        this.$bus.$emit("buscarResultado"); // Chama os resultados
        this.selecionaCenario(1);
      }

      // this.exibirResumoCenario(0, 0, false);
      // this.setFormulariosValidos(0); // Zera o contador de formulários válidos
      // let qtdCenarios = this.intLastIdCenario + 1; // Total de cenários carousel + cenário principal
      // this.$bus.$emit("validarFormulario"); // Valida todos os formulários

      // let formulariosValidos = this.getFormulariosValidos; // Obtém o total de formulários válidos
      // console.log("qtdCenarios", qtdCenarios);
      // console.log("formulariosValidos", formulariosValidos);
      // if (qtdCenarios != formulariosValidos) {
      //   console.log('deu ruim');
      //   this.$bus.$emit("abaAtiva", "error");

      //   // Verifica slides com erro e movimenta até ele
      //   if (this.$refs.carouselResult && this.$refs.carouselResult.$children.length > 1) {
      //     let idSlideErro = this.getIdFormularioErro;
      //     let idPrimeiroSlide = this.slides[0].id;
      //     let paginaSlideErro = idSlideErro != idPrimeiroSlide ? 2 : 1;

      //     this.$bus.$emit("forcePositionCarousel", paginaSlideErro);
      //   }

      //   return false;
      // }

      // this.fetchAlertas();
    },

    buscaResultadosIpiPisCofins: function(idCenario, idRegra) {
      let arIdRegra = this.idRegra;

      if (idRegra == arIdRegra[idCenario] && idRegra != 0) {
        idRegra *= -1;
      }

      arIdRegra[idCenario] = idRegra;
      this.idRegra = arIdRegra;
      this.idRegra[idCenario] = idRegra;

      this.idRegra.splice(idCenario, 1, idRegra);
    },
    // getDadosForm: function(data, numeroCenario) {
    // 	this.arDadosForm[numeroCenario] = data;
    // },
    salvaDadosFormCenario: function(form) {
      if (form.idCenario !== "undefined" && form.idCenario != null) {
        // form.listaCamposObrigatorios = this.listaCamposObrigatorios;
        this.arFormCenario[form.idCenario] = form;
      }
    },
    carregarFormCenarioRefs: function(idSelecionado) {
      this.$refs[idSelecionado][0].carregaCenarioPrincipal();
    },
    carregarFormCenarioCnaes: function(idSelecionado) {
      this.$refs[idSelecionado][0].carregaCenarioCnaes();
    },
    checkDataCnaeCompreende(cnaeId, origem) {
      setTimeout(() => {
        if (typeof cnaeId === "undefined") {
          if (origem == "rem") {
            this.cnaeCompreende = [];
            this.cnaeNaoCompreende = [];
            this.$bus.$emit("enableCompreendeRemetente", false);
          } else {
            this.cnaeCompreendeDestinatario = [];
            this.cnaeNaoCompreendeDestinatario = [];
            this.$bus.$emit("enableCompreendeDestinatario", false);
          }
          return;
        }

        this.loadingCompreende = true;
        new Api()
          .get("Cnae/obterCompreende/" + cnaeId)
          .then(response => {
            if (origem == "rem") {
              this.cnaeCompreende = [];
              if (response.dados[0].compreende !== null) {
                this.cnaeCompreende = response.dados[0].compreende.split("<br>");
              }

              this.cnaeNaoCompreende = [];
              if (response.dados[0].nao_compreende !== null) {
                this.cnaeNaoCompreende = response.dados[0].nao_compreende.split("<br>");
              }
            } else {
              this.cnaeCompreendeDestinatario = [];
              if (response.dados[0].compreende !== null) {
                this.cnaeCompreendeDestinatario = response.dados[0].compreende.split("<br>");
              }

              this.cnaeNaoCompreendeDestinatario = [];
              if (response.dados[0].nao_compreende !== null) {
                this.cnaeNaoCompreendeDestinatario = response.dados[0].nao_compreende.split("<br>");
              }
            }
          })
          .finally(() => {
            if (origem == "rem") {
              if (this.cnaeCompreende.length > 0 || this.cnaeNaoCompreende.length > 0) {
                this.$bus.$emit("enableCompreendeRemetente", true);
              } else {
                this.$bus.$emit("enableCompreendeRemetente", false);
              }
            } else {
              if (
                this.cnaeCompreendeDestinatario.length > 0 ||
                this.cnaeNaoCompreendeDestinatario.length > 0
              ) {
                this.$bus.$emit("enableCompreendeDestinatario", true);
              } else {
                this.$bus.$emit("enableCompreendeDestinatario", false);
              }
            }
            this.loadingCompreende = false;
          });
      }, 500);
    },

    openModalCnaeCompreende: function(cnae) {
      this.cnaeSelecionadaCompreende = cnae;
      this.$root.$emit("bv::show::modal", "ModalCompreende");
    },
    openModalProdutosQuimicos: function() {
      let that = this;
      this.loadingProdutosQuimicos = true;
      this.descricaoQuimicos = "";

      if (this.produtosQuimicos.length == 0) {
        new Api().get("Cenario/obterProdutosQuimicos").then(response => {
          that.produtosQuimicos = response.dados;
          that.loadingProdutosQuimicos = false;
        });
      } else {
        this.loadingProdutosQuimicos = false;
      }

      this.$refs.modalProdutosQuimicos.show();
    },
    closeModalCnaeCompreende: function() {
      this.$refs.modalCnaeCompreende.hide();
    },
    closeModalProdutosQuimicos: function() {
      this.$refs.modalProdutosQuimicos.hide();
    },
    verificarLSIsNull: function(lsItem) {
      if (localStorage.getItem(lsItem) === null) localStorage.removeItem(lsItem);
    },
    moveTo: function(de = "", para = "") {
      let idCenarioSelect = this.idCenarioSelecionado + 1;
      de = de + "-" + idCenarioSelect;

      if (this.idCenarioSelecionado > 0 && this.idCenarioSelecionado < 10) {
      } else {
        this.idCenarioSelecionado = 0;
      }

      idCenarioSelect = 0;

      let content = this.$el.getElementsByClassName(de)[idCenarioSelect];
      let body = this.$el.getElementsByClassName(para)[idCenarioSelect];
      // content.parentNode.removeChild(content);
      if (content != undefined) {
        body.appendChild(content);
      }
    }
  }
};
